module.exports = __webpack_public_path__ + "img/export_bg_fr.38962537.png";